import {defineStore} from 'pinia'
import api from '@/services/api'

export const usePageContentDataStore = defineStore('pageContentData', {
    state: () => ({
        items: []
    }),
    actions: {
        async init() {
            const o = await api.get('api/page-content-link-data')
            
            this.items = o.data
        }
    }
})